/**
 * Copyright IBM Corp. 2022, 2026
 */

import boundary from '@hashicorp/web-mktg-logos/src/boundary/boundary/boundary_on-light.svg'
import consul from '@hashicorp/web-mktg-logos/src/consul/consul/consul_on-light.svg'
import nomad from '@hashicorp/web-mktg-logos/src/nomad/nomad/nomad_on-light.svg'
import packer from '@hashicorp/web-mktg-logos/src/packer/packer/packer_on-light.svg'
import terraform from '@hashicorp/web-mktg-logos/src/terraform/terraform/terraform_on-light.svg'
import vagrant from '@hashicorp/web-mktg-logos/src/vagrant/vagrant/vagrant_on-light.svg'
import vault from '@hashicorp/web-mktg-logos/src/vault/vault/vault_on-light.svg'
import waypoint from '@hashicorp/web-mktg-logos/src/waypoint/waypoint/waypoint_on-light.svg'

export { boundary, consul, nomad, packer, terraform, vagrant, vault, waypoint }
